import * as S from "./WithdrawalPage.styles";
import { MoreTemplates } from "../../components/template/MoreTemplates";
import { useForm } from "react-hook-form";
import { useMutation } from "@tanstack/react-query";
import { request } from "../../lib/api";
import { USER_WITHDRAWAL } from "../../common/query-keys";
import { yupResolver } from "@hookform/resolvers/yup";

import * as yup from "yup";
const WithdrawalPage = () => {
  /** ============================= state 영역 ============================= */
  const { register, handleSubmit, reset } = useForm({
    resolver: yupResolver(
      yup.object({
        name: yup.string().required("이름을 입력해주세요"),
        userId: yup.string().required("아이디를 입력해주세요"),
        phone: yup
          .string()
          .required("휴대폰 번호를 입력해주세요")
          .min(11, "휴대폰 번호를 정확히 입력해주세요"),
      })
    ),
  });

  /** ============================= API 영역 ============================= */

  /** 유저 탈퇴 요청  */
  const { mutateAsync: onUserWithDrawal } = useMutation({
    mutationFn: (data: { name: string; userId: string; phone: string }) => {
      return request({
        method: "POST",
        url: USER_WITHDRAWAL,
        data: data,
      });
    },
    onSuccess: (res: any) => {
      if (res.success) {
        alert(res.message);
        reset({});
      } else {
        alert(res.message);
      }
    },
  });

  /** ============================= 비즈니스 로직 영역 ============================= */

  const onSubmit = (data: any) => {
    console.log(data);
    onUserWithDrawal(data);
  };
  /** ============================= 컴포넌트 영역 ============================= */

  /** ============================= useEffect 영역 ============================= */
  return (
    <MoreTemplates
      pageHeaderTitle="이전"
      pageTitle="회원 탈퇴 요청"
      background="white"
    >
      <S.Withdrawal>
        <S.WithdrawalSection>
          <S.WithdrawalBox>
            <S.TitBox>회원 탈퇴 신청</S.TitBox>
            <S.ContentBox>
              <p>
                서비스 탈퇴 요청 후 영업일 기준 1주일 이내로 회원정보는{" "}
                <S.UnderlineSpan>모두 삭제</S.UnderlineSpan>되며, 탈퇴처리 완료
                시 별도의 문자메세지를 통해 안내해 드립니다.
              </p>
            </S.ContentBox>
            <S.StyledTable>
              <thead>
                <tr>
                  <th>요청</th>
                  <th>삭제되는 정보</th>
                  <th>처리내용</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>회원탈퇴</td>
                  <td>아이디, 이름, 이메일, 차량정보 </td>
                  <td>회원탈퇴 처리 시 즉시 삭제</td>
                </tr>
              </tbody>
            </S.StyledTable>
          </S.WithdrawalBox>
          <S.WithdrawalBox>
            <S.TitBox>
              회원정보 입력 <span>*</span>
            </S.TitBox>
            <S.ContentSubBox>
              <p>탈퇴를 희망하시는 계정의 정보를 입력해 주세요.</p>
            </S.ContentSubBox>
            <S.InputForm onSubmit={handleSubmit(onSubmit)}>
              <S.InputContent>
                <S.InputBoxLayout>
                  <S.LabelContextBox>기본정보 입력</S.LabelContextBox>
                  <S.InputBox>
                    <input
                      type="text"
                      required={true}
                      placeholder="[필수] 이름"
                      {...register("name")}
                    />
                  </S.InputBox>
                </S.InputBoxLayout>
                <S.InputBoxLayout>
                  <S.InputBox>
                    <input
                      type="text"
                      required={true}
                      placeholder="[필수] 아이디"
                      {...register("userId")}
                    />
                  </S.InputBox>
                </S.InputBoxLayout>
                <S.InputBoxLayout>
                  <S.InputBox>
                    <input
                      type="text"
                      placeholder="[필수] 전화번호"
                      {...register("phone")}
                      maxLength={11}
                    />
                  </S.InputBox>
                </S.InputBoxLayout>
              </S.InputContent>
              <button type="submit">회원탈퇴 신청</button>
            </S.InputForm>
          </S.WithdrawalBox>
        </S.WithdrawalSection>
        <S.WithdrawalFooter></S.WithdrawalFooter>
      </S.Withdrawal>
    </MoreTemplates>
  );
};

export default WithdrawalPage;
